import { CONFIG_STORAGE_KEY } from '../constants/config';
import { ConfigResponseData } from '../model';

export const UpdateEventConfigStorageReference = () => {
  const event = new Event('configChange');
  window.dispatchEvent(event);
};

export const getConfigFromStorage = (): ConfigResponseData | null => {
  const configFromStorage = localStorage.getItem(CONFIG_STORAGE_KEY);
  try {
    const config = JSON.parse(configFromStorage ?? '') as ConfigResponseData;

    if (!config) return null;

    return config;
  } catch (error) {
    return null;
  }
};

export const updateConfigStorageReference = (config: ConfigResponseData | null) => {
  if (!config) {
    localStorage.removeItem(CONFIG_STORAGE_KEY);
    UpdateEventConfigStorageReference();
    return;
  }

  localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(config));
  UpdateEventConfigStorageReference();
};
